import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../../../Util/Session/session.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import * as XLSX from 'xlsx';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { EmployeeLeaveManagementService } from '../../../Model/EmployeeLeaveManagement/employee-leave-management.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { GetEmpLeaveMgmtCodeComponent } from '../../get-emp-leave-mgmt-code/get-emp-leave-mgmt-code.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-employee-leave-management',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './employee-leave-management.component.html',
  styleUrl: './employee-leave-management.component.scss'
})
export class EmployeeLeaveManagementComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  EmployeeLeaveManagementData: any[] = [];
  EmployeeType: string = 'Front';
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: any = null;
  // BranchName: string = '';
  ClientId: any = null;
  //ClientName: string = '';
  SiteId: any = null;
  // SiteName: string = '';
  //SiteCode: string = '';
  LeaveTypes = [] as any;
  LeaveMasterId: any = null;
  //LeaveName: string = '';
  YearLoad: any[] = [];
  Year: any = null;
  EmpCode: string = ''
  EmpName: string = ''
  dtoptions: DataTables.Settings = {};
  constructor(private empleavedetailservice: EmployeeLeaveManagementService,
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private leave: LeaveService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.ComboLoad('Year');
    this.LoadEmployeeLeaveCombo();
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.ClientId = null;
      this.ClientLoad = []
      this.SiteId = null
      this.EmployeeLeaveManagementData = [];
    }
    else if (type == 'Client') {
      this.SiteId = null
      this.EmployeeLeaveManagementData = [];
    }
    else if (type === 'Site') {
      this.EmployeeLeaveManagementData = [];
      this.EmpCode = ''
      this.EmpName = ''
    }
    else if (type === 'LeaveType') {
      this.EmployeeLeaveManagementData = [];
    }
    else if (type === 'Year') {
      this.EmployeeLeaveManagementData = [];
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
        else if (Combotype == 'Year') {
          this.YearLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  LoadEmployeeLeaveCombo() {
    this.User = this.sessionService.GetUserDetails();
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.User.UserId, ComboType: 'LeaveMasterPolicy' }).subscribe({
      next: (response) => {
        this.LeaveTypes = response.ComboLoad;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Load(type: string) {
    if (this.BranchId == '' || this.BranchId == null) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    if (this.Year == '' || this.Year == null) {
      this.toast.show({ message: 'Please select Year!', type: toastTypeEnum.warning });
      return;
    }
    if (this.LeaveMasterId == '' || this.LeaveMasterId == null) {
      this.toast.show({ message: 'Please select Leave Type!', type: toastTypeEnum.warning });
      return;
    }
    this.getData(type);
  }
  getData(type: string) {
    this.User = this.sessionService.GetUserDetails();
    if (type === 'A' && this.EmpCode === '') {
      this.toast.show({ message: 'Please Enter Employee Code!', type: toastTypeEnum.warning });
      return
    }
    const LeaveManagementData = {
      SelectType: type,
      BranchID: this.BranchId,
      ClientID: this.ClientId,
      SiteID: this.SiteId,
      EmpType: this.EmployeeType,
      Year: this.Year,
      LeaveTypeID: this.LeaveMasterId,
      EmpLeaveDetailsId: 0,
      EmpMasterId: 0,
      Empcode: this.EmpCode
    };
    this.isDisabled = true;
    this.empleavedetailservice.ESS_EmpLeaveDetailsOBLoad(LeaveManagementData).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          if (type === 'A') {
            const newData = data.Table;
            const exists = newData.some((newItem: { EmpMasterID: any; LeaveMasterID: any; ForYear: any; SiteId: any; }) =>
              this.EmployeeLeaveManagementData.some(item =>
                item.EmpMasterID === newItem.EmpMasterID &&
                item.LeaveMasterID === newItem.LeaveMasterID &&
                item.ForYear === newItem.ForYear &&
                item.SiteId === newItem.SiteId
              )
            );
            if (exists) {
              this.toast.show({ message: 'Data already exists!', type: toastTypeEnum.warning });
              this.isDisabled = false;
            } else {
              this.EmpName = data.Table[0].EmployeeName;
              this.EmployeeLeaveManagementData.push(...newData);
              this.isDisabled = false;
              //this.toast.show({ message: 'Data added successfully!', type: toastTypeEnum.success });
            }
          } else if (type === 'S') {
            this.EmployeeLeaveManagementData = data.Table;
            this.EmpCode = ''
            this.EmpName = ''
            this.isDisabled = false;
            //this.toast.show({ message: 'Data refreshed successfully!', type: toastTypeEnum.success });
          }
        } else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.isDisabled = false;
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  async Save() {
    await this.common.getPageRights();
    if (this.BranchId == '' || this.BranchId == null) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    if (this.Year == '' || this.Year == null) {
      this.toast.show({ message: 'Please select Year!', type: toastTypeEnum.warning });
      return;
    }
    if (this.LeaveMasterId == '' || this.LeaveMasterId == null) {
      this.toast.show({ message: 'Please select Leave Type!', type: toastTypeEnum.warning });
      return;
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.update();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  update() {
    if (this.EmployeeLeaveManagementData.length <= 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return;
    }
    this.User = this.sessionService.GetUserDetails();
    const LeaveManagement = this.EmployeeLeaveManagementData.map(leave => {
      return {
        EmpMasterId: leave.EmpMasterID,
        EmpType: leave.EmpType,
        SiteId: leave.SiteMasterID,
        LeaveMasterId: leave.LeaveMasterID,
        OpeningBalance: leave.OpeningBalance,
        ForYear: leave.ForYear
      };
    });
    const InsertUpdate = {
      SelectType: 'I',
      ESS_EmpLeaveDetails_OB: LeaveManagement,
      UserId: this.User.UserId
    };
    this.isDisabled = true;
    this.empleavedetailservice.ESS_EmpLeaveDetailsOBUpdate(InsertUpdate).subscribe(
      data => {
        if (data.Error_Code == 294) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.EmployeeLeaveManagementData = [];
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  OpenToSearch() {
    if (this.EmpCode === '') {
      this.toast.show({ message: 'Please Enter Employee Code!', type: toastTypeEnum.warning });
      return
    }
    const LeaveManagementData = {
      SelectType: 'A',
      BranchID: this.BranchId,
      ClientID: this.ClientId === null ? 0 : this.ClientId,
      SiteID: this.SiteId === null ? 0 : this.SiteId,
      EmpType: this.EmployeeType,
      Year: this.Year,
      LeaveTypeID: this.LeaveMasterId,
      EmpLeaveDetailsId: 0,
      EmpMasterId: 0,
      Empcode: this.EmpCode
    };
    this.empleavedetailservice.ESS_EmpLeaveDetailsOBLoad(LeaveManagementData).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.EmpName = data.Table[0].EmployeeName;
          const dat = {
            Empcode: this.EmpCode,
            EmployeeName: this.EmpName
          };
          const modalOptions: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            size: 'md'
          };
          const modalRef = this.modalService.open(GetEmpLeaveMgmtCodeComponent, modalOptions);
          modalRef.componentInstance.data = dat;
          modalRef.result.then((result) => {
            if (result === true) {
              this.getData('A');
            } else {
              return
            }
          }).catch((reason) => {
            console.log('Modal dismissed:', reason);
          });

        }
        else {
          this.toast.show({ message: 'Employee not found!', type: toastTypeEnum.warning });
        }
      });

  }


  Excel() {
    this.isDisabled = true;
    if (this.EmployeeLeaveManagementData.length > 0) {
      this.download.exportToExcel(this.EmployeeLeaveManagementData, "EmployeeLeaveManagementFront_data");
      this.isDisabled = false
    }
    else {
      this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
      this.isDisabled = false
    }
  }
  downloadExcel() {
    this.download.downloadExcel('EmployeeLeaveManagement_Front');
  }
  handleFileInput(event: any): void {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }

        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

        // Assuming the excelData has the columns: EmpCode, Year, LeaveName, OpeningBalance
        const updatedData = excelData.slice(1); // Remove header row
        updatedData.forEach(row => {
          const siteCode = row[0];
          const empCode = row[1]; // EmpCode from Excel
          const openingBalance = row[4]; // OpeningBalance from Excel

          // Find the matching employee in EmployeeLeaveManagementData
          const employee = this.EmployeeLeaveManagementData.find(emp => emp.EmpCode === empCode && emp.SiteCode === siteCode);

          if (employee) {
            // Update the OpeningBalance
            employee.OpeningBalance = openingBalance;
          }
        });

        // You can now trigger any UI update or further operations if needed
        //this.dtTrigger.next();
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

}
